import PageLayout from "@/components/feature/PageLayout";
import AnimatedSection from "@/components/AnimatedSection";

export default function NotFound() {
  return (
    <PageLayout>
      <section className="relative min-h-[70vh] flex items-center justify-center py-24 bg-hero-gradient overflow-hidden">
          <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E\")" }} />

          {/* Decorative floating tech elements */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div className="absolute top-20 left-[12%] w-24 h-24 rounded-2xl bg-accent-500/10 border border-accent-400/20 animate-float" />
            <div className="absolute bottom-24 left-[18%] w-16 h-16 rounded-xl bg-secondary-500/10 border border-secondary-400/20 animate-float-delay-1" />
            <div className="absolute top-32 right-[14%] w-20 h-20 rounded-2xl bg-orange-500/10 border border-orange-400/20 animate-float-delay-2" />
            <div className="absolute bottom-32 right-[20%] w-28 h-28 rounded-2xl bg-primary-500/10 border border-primary-400/20 animate-float-delay-3" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-accent-500/5 blur-3xl" />
          </div>

          <div className="container-astro relative z-10 text-center px-4">
            <AnimatedSection>
              <p className="text-[110px] md:text-[160px] leading-none font-black text-transparent bg-clip-text bg-gradient-to-r from-[#2563EB] via-[#7C3AED] to-[#F97316] font-heading select-none">
                404
              </p>
            </AnimatedSection>
            <AnimatedSection delay={100}>
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/10 border border-accent-500/20 mb-6">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse-dot" />
                <span className="text-xs font-semibold text-accent-300 tracking-wide uppercase">Page Not Found</span>
              </div>
            </AnimatedSection>
            <AnimatedSection delay={200}>
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-background-50 mb-5 font-heading tracking-tight">
                Looks Like This Page Went Offline
              </h1>
            </AnimatedSection>
            <AnimatedSection delay={300}>
              <p className="text-base md:text-lg text-background-400 max-w-xl mx-auto mb-10 leading-relaxed">
                The page you're looking for doesn't exist or may have been moved. Let's get you back on track.
              </p>
            </AnimatedSection>
            <AnimatedSection delay={400}>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href="/"
                  className="inline-flex items-center gap-2 px-7 py-3.5 bg-gradient-to-r from-[#2563EB] via-[#7C3AED] to-[#F97316] text-white text-sm font-semibold rounded-xl hover:brightness-110 hover:-translate-y-0.5 transition-all duration-300 shadow-lg shadow-[#7C3AED]/25 whitespace-nowrap btn-arrow-hover group"
                >
                  Back to Home
                  <i className="ri-home-line btn-arrow transition-transform duration-300 group-hover:translate-x-1" />
                </a>
                <a
                  href="/contact-us"
                  className="inline-flex items-center gap-2 px-7 py-3.5 border border-white/30 text-white text-sm font-semibold rounded-xl hover:bg-white/10 hover:-translate-y-0.5 transition-all duration-300 whitespace-nowrap btn-arrow-hover group"
                >
                  Contact Us
                  <i className="ri-chat-1-line btn-arrow transition-transform duration-300 group-hover:translate-x-1" />
                </a>
              </div>
            </AnimatedSection>
          </div>
        </section>
    </PageLayout>
  );
}